import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import { useNavigate } from 'react-router';

import useAccountQuery from 'api/queries/useAccountQuery';
import useSelectionsQuery from 'api/queries/useSelectionsQuery';
import useShopWithPointsProductsQuery from 'api/queries/useShopWithPointsProductsQuery';
import { Breadcrumbs } from 'honeydew/Breadcrumbs';
import Loader from 'honeydew/Loader';
import LoyaltyPointsBanner from 'shared/LoyaltyPointsBanner';
import ServiceDelayBanners from 'shared/ServiceDelayBanners';
import { getLoyaltyPointsBalance } from 'utils/shopUtils';

import ProductTabs from './ProductTabs';

function ShopWithPoints() {
    const navigate = useNavigate();
    const { data: account = {} } = useAccountQuery();
    const { data: selections = [] } = useSelectionsQuery();

    const { data: products, isLoading: loading } = useShopWithPointsProductsQuery();

    const breadcrumbs = [
        {
            id: 1,
            title: 'Home',
            url: '/shop',
        },
        {
            id: 2,
            title: 'Shop with Points',
            subtitle: loading ? '' : `(${products.length})`,
        },
    ];

    return (
        <section className="md:mx-10">
            <div className="mx-10 mb-10 pt-20 md:mx-0 md:mt-0 md:pt-40">
                <Breadcrumbs breadcrumbs={breadcrumbs} showLast className="md:mb-20 md:pt-20" />
            </div>
            <div className="mx-10 mb-20 flex items-center gap-10 md:mx-0">
                <button
                    onClick={() => navigate('/shop')}
                    type="button"
                    className="shadow-base mr-5 rounded-full p-[3px]"
                >
                    <ArrowLeftIcon className="h-[24px] w-[24px]" />
                </button>
                <h1 className="text-heading-xs">Shop with Points</h1>
            </div>
            <ServiceDelayBanners className="mb-20 px-10" />
            <LoyaltyPointsBanner
                points={getLoyaltyPointsBalance(account?.currentLoyaltyPoints, selections)}
                roundedBottom={false}
            />
            {loading ? (
                <div className="my-40 flex justify-center">
                    <Loader width="60" />
                </div>
            ) : (
                <div className="mx-10 md:mx-0">
                    <ProductTabs products={products} />
                </div>
            )}
        </section>
    );
}

export { ShopWithPoints as Component };
